module.exports = __webpack_public_path__ + "img/linkedin.efd06ac6.svg";